export const categories = [
  "SaaS",
  "E-commerce",
  "FinTech",
  "HealthTech",
  "EdTech",
  "AI/ML",
  "Blockchain",
  "Mobile App",
  "Hardware",
  "Other"
];

export const stages = [
  "Idea",
  "Prototype",
  "MVP",
  "Beta",
  "Growth",
  "Scale",
  "Series A",
  "Series B"
];